import clsx from 'clsx';
import React, { useState } from 'react';

interface TogglerProps {
  label: string;
  onClick: (active: boolean) => void;
  initialState?: boolean;
  className?: string;
}

const Toggler = ({
  label,
  onClick,
  initialState = false,
  className,
}: TogglerProps) => {
  const [active, setIsActive] = useState(initialState);
  const handleOnClick = (onClick) => {
    onClick(!active);
    setIsActive(!active);
  };
  return (
    <div
      onClick={() => handleOnClick(onClick)}
      className={clsx(
        'flex items-center gap-3 py-2.5 hover:cursor-pointer lg:py-0',
        className
      )}
    >
      <label className="text-sm font-normal uppercase">{label}</label>
      <div
        className={clsx(
          'flex h-5 w-10 items-center rounded-[20px] p-0.5',
          active ? 'bg-gray-700' : 'bg-gray-200'
        )}
      >
        <div
          className={clsx(
            'absolute h-4 w-4 rounded-full bg-white transition-all duration-200',
            active ? 'translate-x-5' : 'translate-x-0'
          )}
        ></div>
      </div>
    </div>
  );
};

export default Toggler;
